<template>

    <div class="toggle" :class="toggle ? 'active' : ''">
        <span></span>
        <span></span>
        <span></span>
    </div>

</template>
<script>
export default {
    name: "ToggleButton",
    props: ['toggle']
}
</script>
<style scoped lang="less">
.toggle {
    width: 40px;
    height: 40px;
    position: relative;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    // box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    overflow: hidden;
}

.toggle span {
    position: absolute;
    width: 25px;
    height: 3px;
    background-color: #1863ff;
    border-radius: 3px;
    transition: 0.5s;
}


.toggle span:nth-child(1) {
    transform: translateY(-10px);
    width: 15px;
    left: 7.5px;
}

.toggle.active span:nth-child(1) {
    transform: translateY(0) rotate(45deg);
    width: 25px;
}

.toggle span:nth-child(2) {
    transform: translateY(10px);
    width: 10px;
    left: 7.5px;
}

.toggle.active span:nth-child(2) {
    transform: translateY(0) rotate(-45deg);
    width: 25px;
}


.toggle.active span:nth-child(3) {
    transform: translateX(60px);
}
</style>